
import React from 'react';

export const AttachmentIcon = () => (
  <svg className="w-[18px] h-[18px]" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.375 4.5V13.125C12.375 14.7825 11.0325 16.125 9.375 16.125C7.7175 16.125 6.375 14.7825 6.375 13.125V3.75C6.375 2.715 7.215 1.875 8.25 1.875C9.285 1.875 10.125 2.715 10.125 3.75V11.625C10.125 12.0375 9.7875 12.375 9.375 12.375C8.9625 12.375 8.625 12.0375 8.625 11.625V4.5H7.5V11.625C7.5 12.66 8.34 13.5 9.375 13.5C10.41 13.5 11.25 12.66 11.25 11.625V3.75C11.25 2.0925 9.9075 0.75 8.25 0.75C6.5925 0.75 5.25 2.0925 5.25 3.75V13.125C5.25 15.405 7.095 17.25 9.375 17.25C11.655 17.25 13.5 15.405 13.5 13.125V4.5H12.375Z" fill="#292929" />
  </svg>
);
